module.exports = __webpack_public_path__ + "7db970fd6f5ff4dc8cb591a396408f81.md";